export default {
  title: 'Fermer la disponibilité',
  close_availabilities_form: {
    date_range: {
      label: 'Sélectionner une date et une heure.',
    },
  },
  reason: {
    label: 'Ajouter une raison (facultatif)',
    placeholder: 'Saisir une description...',
  },
  recurring: {
    label: 'Récurrent annuellement',
  },
  buttons: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    add: '+ Ajouter une exception',
    reactivate: 'Réactiver',
  },
  reservations: {
    title: 'Réservations',
    description: "Voulez-vous ajouter l'exception de planning aux réservations ?",
    add: 'Ajouter',
    cancel: 'Annuler',
  },
  projects: {
    online_shop: 'Boutique en ligne',
    reservations: 'Réservations',
    storefront: 'Vitrine',
  },
  success_messages: {
    reservation_updated: 'Exception de planning ajoutée avec succès',
  },
  error_messages: {
    date_range_required: 'Veuillez sélectionner une plage de dates.',
    creation_failed: "Échec de la création de l'exception",
    overlapping_schedule_exception: 'Une exception de planning existe déjà pour cette plage horaire',
    merge_schedule_exceptions:
      "L'exception de planning {{oldDate}} sera fusionnée avec {{newDate}}. Vous pouvez également mettre à jour la plage de dates pour {{oldDate}}.",
  },
};
